/* eslint-disable react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { getCurrencyCode } from 'utils/helpers';
import AccordionTooltip from 'components/common/controls/AccordionTooltip';

const propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.string,
  valueMod: PropTypes.string,
  isTitleTooltip: PropTypes.bool,
};

const CreditInformationItem = (props) => {
  const {
    id, value, style, isTitleTooltip, valueMod,
  } = props;
  return (
    <div className="credit-info__item">
      {isTitleTooltip
        && (
        <AccordionTooltip
          title={<FormattedMessage id={`selfservice.creditInformation.${id}`} />}
          hideIcon={MOBILE_WALLET}
        >
          <div className="credit-info__item-tooltip">
            <FormattedMessage id={`selfservice.creditInformation.${id}.tooltip`} />
          </div>
        </AccordionTooltip>
        )}
      {!isTitleTooltip
        && <FormattedMessage id={`selfservice.creditInformation.${id}`} />}
      <div
        className={
          cx({
            'credit-info__item-value': true,
            [`credit-info__item-value--${valueMod}`]: valueMod,
          })
        }
      >
        {style === 'percent'
          && (
          <FormattedNumber
            style="percent"
            minimumFractionDigits={2}
            maximumFractionDigits={2}
            value={value / 100}
          />
          )}
        {(!style || style === 'currency') // To be sure no existing implementations break
          && (
          <FormattedNumber
            style="currency"
            currency={getCurrencyCode()}
            value={value}
          />
          )}
        {style === 'currency_int'
          && (
          <FormattedNumber
            style="currency"
            currency={getCurrencyCode()}
            value={value}
            minimumFractionDigits={0}
            maximumFractionDigits={0}
          />
          )}
        {style === 'string'
          && value}
      </div>
    </div>
  );
};

CreditInformationItem.propTypes = propTypes;

export default CreditInformationItem;
